import React from 'react';
import SingleBannerLogo from '../../../../Assets/StorefrontIcons/SingleBannerLogo.svg';
import { useDispatch, useSelector } from 'react-redux';
import { setSectionFormType } from '../../../../Features/storefrontSlice';

function SingleBannerButton() {
    const dispatch = useDispatch();

    const viewType = useSelector((state) => state.storefront.viewType);

    function handleClick() {
        dispatch(setSectionFormType(`SINGLE_BANNER${viewType === 'MOBILE' ? '' : '_DESKTOP'}`));
    }

    return (
        <button onClick={handleClick} className="p-[10px] border border-[#EAEAEA] flex flex-col items-center gap-2 rounded-2xl outline-none select-none">
            <div className="w-full h-[100px] flex items-center justify-center rounded-md bg-[#EAEAEA]">
                <img className='max-w-full max-h-full' src={SingleBannerLogo} alt="" />
            </div>

            <p className='font-medium text-[12px] leading-5 text-[#121212]'>Single Banner</p>
        </button>
    );
}

export default SingleBannerButton;
